import axios from "axios";

const baseDomain = process.env.VUE_APP_API_URL;

const patientApiService = {
  async getInformation(patientID) {
    const result = await axios.get(
      `${baseDomain}/api/v1/user/${patientID}`
    );
    return result.data || null;
  },

  async getCases(patientID) {
    const result = await axios.get(
      `${baseDomain}/api/v2/case?patient_id=${patientID}`
    );
    return result.data || null;
  },
};

export default patientApiService;
